import { EnvironmentEnum } from './environment.enum';

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  ambiente: EnvironmentEnum.DEVELOPMENT,
  apiOld: (service) => `https://ps-${service}-api.dev.publicservice.com.br`,
  apiAssinatura: (path) =>
    `https://ps-assinatura-documentos-api.dev.publicservice.com.br/${path}`,
  apiUrl: (service) => `https://ps-${service}-api.dev.publicservice.com.br`,
  apiTools: (service) => `https://ps-${service}-api.api.publicservice.com.br`,
  appUrl: (service) => `https://ps-${service}-app.dev.publicservice.com.br`,
  domain: 'dev.publicservice.com.br',
};
